<template>
  <v-app>
    <v-content class="background-theme">
      <router-view/>
    </v-content>
  </v-app>
</template>
<script>

export default {
  name: 'App',

  data: () => ({
    //
  }),
};
</script>

<style>
  @import url('https://fonts.googleapis.com/css?family=Noto+Sans+Thai&display=swap');
  @import url('https://fonts.googleapis.com/css?family=Sarabun&display=swap');
  
  .background-theme {
    background-color: #F0F0F0 !important;
    background-image: radial-gradient(circle 340px at 10% 7%, rgba(59, 115, 201, 0.136) 55%, transparent 100%),
      radial-gradient(circle 225px at 40% 7%, rgba(59, 201, 133, 0.136) 55%, transparent 100%),
      radial-gradient(circle 225px at 95% 70%, rgba(59, 201, 133, 0.136) 55%, transparent 100%) !important;
    background-size: 100% 100%, 100% 100%;
    background-repeat: no-repeat;
  }

  .standard-row {
    width: 100%;
    margin: 0% !important;
  }

  .font-theme {
    font-family: 'Noto Sans Thai', sans-serif !important;
    letter-spacing: 0.1px !important;
  }

  .scroll-theme::-webkit-scrollbar {
    width: 12px;
  }

  .scroll-theme::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: transparent !important;
  }

  .scroll-theme::-webkit-scrollbar {
    width: 8px;
    background-color: transparent !important;
  }

  .scroll-theme::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #eaf1f6;
  }
  
  .alert-card-block {
    top: 108px !important;
    width: auto !important;
  }

  .alert-card-success {
    border: 1px solid #000000 !important;
    border-radius: 20px !important;
    padding: 20px !important;
    box-shadow: none !important;
  }

  .alert-title-block {
    text-align: start !important;
    padding: 0px !important;
    margin: 0px !important;
  }

  .alert-text-box {
    font-family: 'Noto Sans Thai', sans-serif !important;
    color: #050505 !important;
    font-size: 20px !important;
    text-align: start !important;
    font-weight: 300 !important;
    margin: 0px !important;
  }

  .alert-success-title {
    font-weight: 400 !important;
    font-size: 20px !important;
    font-family: 'Noto Sans Thai', sans-serif !important;
    margin: 0px !important;
  }

  .alert-icon {
    font-size: 30px !important;
  }

  .animate-show-card {
    opacity: 0;
    transform: scale(0.7);
    animation: alert-show-animation 0.3s ease-out forwards;
  }

  @keyframes alert-show-animation {
    0% {
      opacity: 0;
      transform: scale(0.7);
    }
    100% {
      opacity: 1;
      transform: scale(1);
    }
  }

  @media only screen and (max-width:600px){ /*css for mobile screen*/
    .display-pc-only {
      display: none !important;
    }
  }

  /*==========================================*/

  @media only screen and (min-width: 600px) { /*css for pc screen*/
    .display-mobile-only {
      display: none !important;
    }
  }
</style>
